// components/Mark.tsx — the UPLOAD symbol: a monogram "U" (you / a private vessel)
// with a node lifting from its opening (your distilled self, uploading). Inherits
// `currentColor` so it themes with the surrounding text.
import type { SVGProps } from 'react';

export function Mark({ className = 'h-6 w-6', ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 64 64" fill="none" aria-hidden="true" className={className} {...props}>
      <path
        d="M20 22 V36 A12 12 0 0 0 44 36 V22"
        stroke="currentColor"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <circle cx="32" cy="13.5" r="4.6" fill="currentColor" />
    </svg>
  );
}
